import { Position, Toaster, Intent } from "@blueprintjs/core";

const toaster = Toaster.create({
    position: Position.TOP,
})

const toaster_BOT = Toaster.create({
    position: Position.BOTTOM,
})

export const showError = (err: any) => {
    if (err.response) {
        //toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        toaster.show({ message: (err.response.data.osCode > 0 ? "Error:"+err.response.data.subSystem +" - ": "")+err.response.data.description+(err.response.data.osCode > 0 ? ", OS code:"+err.response.data.osCode : ""), intent: Intent.WARNING })
    } else if (err.request) {
        toaster.show({ message: "Request failed", intent: Intent.WARNING })
    } else if (err.message) {
        toaster.show({ message: err.message, intent: Intent.WARNING })
    } else {
        toaster.show({ message: err, intent: Intent.WARNING })
    }
}


export const showError2 = (err: any) => {
    // AppToaster.show({ message: "Toasted." });
    if (err.response) {
        //toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        toaster.show({ message: (err.response.data.osCode > 0 ? "Error:"+err.response.data.subSystem +" - ": "")+err.response.data.description+(err.response.data.osCode > 0 ? ", OS code:"+err.response.data.osCode : ""), icon: "warning-sign", intent: Intent.WARNING })
    } else if (err.request) {
        toaster.show({ message: "Request failed", intent: Intent.WARNING })
    } else if (err.message) {
        toaster.show({ message: err.message, icon: "warning-sign", intent: Intent.WARNING })
    } else {
        toaster.show({ message: err,  icon: "warning-sign", intent: Intent.WARNING })
    }
}


export const showSuccess = (message: string) => {
    toaster.show({ message: message, intent: Intent.SUCCESS })
}


export const showSuccess_BOT = (message: string) => {
    toaster_BOT.show({ message: message, icon:"tick", intent: Intent.SUCCESS })
}

export const showWarn = (message: string) => {
    toaster.show({ message: message, intent: Intent.WARNING })
}

export function handleStringChange(handler: (value: string) => void) {
    return (event: React.FormEvent<HTMLElement>) => handler((event.target as HTMLInputElement).value);
}


/**
 * Higher-order function for onChange events.
 * Filters input to allow only numbers and a single decimal point.
 */
export function handleStringChange2(handler: (value: string) => void) {
    return (event: React.FormEvent<HTMLElement>) => {
        const val = (event.target as HTMLInputElement).value;
        // Allow only digits and a single decimal point
        if (val === "" || /^[0-9]*\.?[0-9]*$/.test(val)) {
            handler(val);
        }
    };
}

/**
 * Higher-order function for onBlur events.
 * Automatically prepends '0' if the value starts with '.' (e.g., .45 -> 0.45).
 * Does nothing if the value already starts with '0' or a digit (e.g., 0.45 remains 0.45).
 */
export function handleNumericBlur(handler: (value: string) => void) {
    return (event: React.FocusEvent<HTMLInputElement>) => {
        let val = event.target.value.trim();

        // Step 1: Remove existing commas to normalize the string
        let cleanVal = val.replace(/,/g, '');

        // Step 2: Remove redundant leading zeros (e.g., 0001223 -> 1223)
        // This regex ensures '0.' or a single '0' is not stripped
        cleanVal = cleanVal.replace(/^0+(?!\.|$)/, '');

        // Step 3: Fix leading dots (e.g., .45 -> 0.45)
        if (cleanVal.startsWith('.')) {
            cleanVal = '0' + cleanVal;
        }

        // Step 4: Format with thousands separators if it's a valid number
        if (cleanVal !== "" && !isNaN(Number(cleanVal))) {
            const parts = cleanVal.split('.');
            
            // Format only the integer part
            parts[0] = parts[0].replace(/\B(?=(\d{6})+(?!\d))/g, ",");
            
            const formatted = parts.join('.');

            // Update DOM display and parent state
            event.target.value = formatted;
            handler(formatted);
        } 
        // Cleanup if the value is just "." or empty
        else if (cleanVal === "" || cleanVal === ".") {
            event.target.value = "";
            handler("");
        }
    };
}
export function handleThousandsChange(handler: (value: string) => void) {
    return (event: React.FormEvent<HTMLElement>) => {
        const val = (event.target as HTMLInputElement).value;

        // REGEX: ^[0-9.,]*$ 
        // Allows only numbers, dots, and commas.
        const isNumeric = /^[0-9.,]*$/.test(val);

        // Check to ensure only one decimal point exists
        const dotCount = (val.match(/\./g) || []).length;

        // If valid, call the handler to update State
        if (isNumeric && dotCount <= 1) {
            handler(val);
        }  
    };
}
/*
export function handleThousandsChange2(handler: (value: string) => void) {
    return (event: React.FormEvent<HTMLElement>) => {
        const val = (event.target as HTMLInputElement).value;
        // Regex: Allow only numbers, one dot, and commas
        if (val === "" || /^[0-9.,]*$/.test(val)) {
            handler(val);
        }
    };
}
*/

/**
 * Higher-order function for onBlur events.
 * 1. Converts ".45" to "0.45"
 * 2. Adds thousands separators: "1000" -> "1,000"
 * 3. Prevents "0.45" from becoming "00.45"
 */
export function handleThousandsBlur(handler: (value: string) => void) {
    return (event: React.FocusEvent<HTMLInputElement>) => {
        let val = event.target.value;

        // Step 1: Strip existing commas to clean the string
        let cleanVal = val.replace(/,/g, '');

        // Step 2: Fix leading dots (.45 -> 0.45)
        if (cleanVal.startsWith('.')) {
            cleanVal = '0' + cleanVal;
        }
        cleanVal = cleanVal.replace(/^0+(?!\.|$)/, '');
        // Step 3: Format integer part with thousands separators
        if (cleanVal !== "" && !isNaN(Number(cleanVal))) {
            const parts = cleanVal.split('.');
            // Regex to insert commas every 3 digits
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            
            const formatted = parts.join('.');

            // Update both UI and State
            event.target.value = formatted; 
            handler(formatted);             
        } else if (cleanVal === "") {
            handler("");
        }
    };
}

export function stripCommas(value: string): string {
    return value.replace(/,/g, '');
}


export function formatToThousands(value: string | number): string {
    if (value === undefined || value === null || value === "") return "";

    let str = "";

    if (typeof value === "number") {
        // Step 1: Fix float noise and scientific notation
        // Round to 10 decimal places and remove trailing zeros
        str = value.toFixed(10).replace(/\.?0+$/, "");
    } else {
        // Step 2: If it's a string, strip existing commas first
        str = value.toString().replace(/,/g, '');
    }

    // Step 3: Handle leading dot (.45 -> 0.45)
    if (str.startsWith('.')) {
        str = '0' + str;
    }

    // Step 4: Split into Integer and Decimal parts
    const parts = str.split('.');
    
    // Step 5: Add commas only to the Integer part
    // Regex: inserts commas every 3 digits
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Rejoin the parts (e.g., "1,322" + "." + "475")
    return parts.join('.');
}

export function handleBooleanChange(handler: (checked: boolean) => void) {
    return (event: React.FormEvent<HTMLElement>) => handler((event.target as HTMLInputElement).checked);
}

export function handleSelectBooleanChange(handler: (value: boolean) => void) {
  return (event: React.ChangeEvent<HTMLSelectElement>) => {
    handler(event.target.value === "true");
  };
}

export function handleNumberChange(handler: (value: number) => void) {
    return handleStringChange(value => handler(+value));
}

export function handleNumberChange2(handler: (value: number) => void) {
    return handleStringChange(value => handler(+value));
}


/**20260910
 
 * Intercepts non-digits and leading zeros directly in the DOM to eliminate flickering,
 * then synchronizes the sanitized value with React Hook Form.
 */
export function handleBcanNumberChange(fieldName: string, setValueFn: (name: string, value: any, shouldValidate?: boolean) => void) {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
        // 1. Strip all non-digits, then remove all leading zeros (e.g., "005" -> "5")
        const cleaned = e.target.value.replace(/\D/g, '').replace(/^0+/, '');
        
        // 2. CRITICAL: Directly overwrite the DOM node value so the browser never renders a temporary "0"
        e.target.value = cleaned;
        
        // 3. Update the React Hook Form internal state (passing true directly for older RHF version support)
        setValueFn(fieldName, cleaned as any, true);
    };
}

export function formatMoney(n: any, d:number = 2): string {
    //if (typeof n === "number")
        return roundMoney(Number(n), d).toLocaleString(undefined, { minimumFractionDigits: d });
    //return ""
}

export function roundMoney(n: any, d:number = 2): number {
    if (typeof n === "number")
        return Number.parseFloat(n.toFixed(d));
    return 0
}
export function stringToBoolean  (stringValue:string)  {
    switch(stringValue?.toUpperCase()?.trim()){
        case 'Y':

          return true;
       default:
       
          return false;     
    }
}

export function BooleanTostring (bool1:boolean)  {
    switch(bool1){
        case true:
          return "Y";

        default: 
          return "N";
    }
}





export function formatNumber(n: any): string {
    if (typeof n === "number")
        return n.toLocaleString();
    return ""
}

export function formatNumber2(n: any): string {
    if (typeof n === "number")
        //return n.toString();
        return addCommas(n)
    return ""
}

export function formatNumber3(n: any, d:number = 4): string {
    if (typeof n === "number")
        //return n.toString();
        return addCommas(Number.parseFloat(n.toFixed(d)))
    return ""
}

export function numToString(n: any): string {
    if (typeof n === "number")
        return n.toString();
    return ""
}


/**
 * 0. convert any to number
 * 1. Forced precision (123304 -> "123,304.00")
 * 2. Rounds to 2 decimal places (5550.3766 -> "5,550.38")
 * 3. Removes leading zeros (0123304 -> "123,304.00")
 */
export function numToStringFix(n: any, precision: number = 2): string {
    const num = Number(n);

    if (n !== "" && n !== null && !isNaN(num)) {
        return num.toLocaleString('en-US', {
            // Force exactly 'precision' number of decimal places
            minimumFractionDigits: precision, 
            maximumFractionDigits: precision 
        });
    }
    
    // Fallback for invalid input, ensuring we return at least "0.00" if preferred
    return n?.toString() || "";
}

// add Commas
export function numToString2(n: any): string {
    if (typeof n === "number")
        return addCommas(n).toString();
    return ""
}

export function StringToNum(x: any): number {
    if (typeof x === "number") {
        return x;
    }
    let n = Number.parseFloat(x)
    return Number.isNaN(n) ? 0 : n
}

// remove Commas
export function StringToNum2(x: any): number {
    if (typeof x === "number") {
        return x;
    }
    let n = removeCommas(x)
    n = Number.parseFloat(n)
    return Number.isNaN(n) ? 0 : n
}

export function ParseFloat(str:any,d:number = 4):string {

    if (typeof str === "number")
    {      // console.log("number")
        let n   = Number.parseFloat(String(str)) 
        let str1 = (n.toFixed(d))
        return str1;
    }
    /*
    else if  (typeof str ==="string")
    {
        let n =0
        let str1 =''
        if (str.length == 0)
        {
           
            let str1 = (n.toFixed(d)).toString()
        }
        return str1;
    }
    */
    //str = str.toString();
    //console.log("string")
    let n   = Number.parseFloat(str) 
  
    let str1 = (n.toFixed(d))
    if (str1 === "NaN")
    {
        let n =0
        let str1 = (n.toFixed(d)).toString()
    }
    return str1
  
     
}


export function numToString3(str: any,d:number = 2): string {
    var x1="";
    var x2="";
    let str1;
    if (typeof str === "number")
    {
        let n   = Number.parseFloat(String(str)) 
        str1 = (n.toFixed(2)) 
    }

    return addCommas(str1).toString();

}
 




export function genUUID(): string {
    var d = Date.now();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}
  


function addCommas(nStr: any)
{
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

function removeCommas(nStr: any)
{
    nStr = parseFloat(nStr.replace(/,/g, '')) ;
    return nStr;
}

export function fileBase(path: string): string {
    return path.replace(/^.*\\/, "");
}


export function fileSize(n: number): string {
    if (n >= 1024**3) {
        return (n / (1024**3)).toFixed(1)+" TB"
    }
    if (n >= 1024**2) {
        return (n / (1024**2)).toFixed(1)+" MB"
    }
    if (n >= 1024) {
        return (n / (1024)).toFixed(1)+" KB"
    }
    return n.toLocaleString()
}


export function getUrlParameter(name: string, url: string): string {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


// device detection
export function getDeviceType():boolean {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
    return check;
}


export function isTouchDev():boolean {
    try{ document.createEvent("TouchEvent"); return true; }
    catch(e){ return false; }
}


export function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}



//           1
// 01234567890123456
// yyyymmddhhmmssfff
export function hb_StoD(s: string): Date {
    //convert YYYYMMDDhhmmssfff to date format
    let dateString = s.slice(0,4)+'-'+s.slice(4,6)+'-'+s.slice(6,8)+'T'+s.slice(8,10)+':'+s.slice(10,12)+':'+s.slice(12,14)+'.'+s.slice(14,17)
    return new Date(dateString)
}

export function hb_DtoS(d: Date): string {
    // date format to YYYY-MM-DD
    let dateValue =  d.toLocaleString();
    dateValue = dateValue.substr(0,4) +"-"+ dateValue.substr(4,2) +"-"+ dateValue.substr(6,2);
    return dateValue
}

export function dispDate(d_s: string, d_type: string): string {
    // disp in textbox only
    // in calendar: For Chrome, Firefox, and Opera, the formatting of the input field's text is based on the browser's language setting.
    //              For Edge, it is based on the Windows language setting.
    // 0123456789
    //d_type = "0"
    // YYYY-MM-DD => YYYY-MM-DD  (ie no change)
    //d_type = "1"
    // YYYY-MM-DD => DD-MM-YYYY
    //d_type = "2"
    // YYYY-MM-DD => MM-DD-YYYY
    //d_type = "3"
    // YYYY-MM-DD => YYYYMMDD

    if ( typeof(d_s) === "undefined") {
        d_s = ""
    }
    if ( d_s === null ) {
        d_s = ""
    }

    let ret_string = d_s;
    if (d_type==="0") {
    } else if (d_type==="1") {
        ret_string = ret_string.substr(8,2) +"-"+ ret_string.substr(5,2) +"-"+ ret_string.substr(0,4)
    } else  if (d_type==="2") {
        ret_string = ret_string.substr(5,2) +"-"+ ret_string.substr(8,2) +"-"+ ret_string.substr(0,4)
    } else  if (d_type==="3") {
        ret_string = ret_string.substr(0,4) + ret_string.substr(5,2) + ret_string.substr(8,2)
    }

    return ret_string
}

export function formatTime(d: Date): string {
    return d.toLocaleTimeString([], {hour12: false})
}


export function STRVAL(GsbFlag: any, cStkNo: string): string {

    //console.log("STRVAL cStkNo type: ", typeof(cStkNo))
    if ( typeof(cStkNo) === "undefined") {
        cStkNo = ""
    }

    let STKNO_LEN = GsbFlag.STKNO_LEN
    let P_LEN = cStkNo.length

    if ( cStkNo.trim().length === 0 )
    {
        return " ".repeat(STKNO_LEN)
    }

    let lHasNum = ! Number.isNaN(Number(cStkNo))
    //console.log("STRVAL lHasNum: ", lHasNum, cStkNo)
 
    //console.log("STRVAL GsbFlag.SAS_MKT: ", GsbFlag.SAS_MKT)
    if ( GsbFlag.SAS_MKT || GsbFlag.MULTI_MKT )
    {
        if ( lHasNum )
        {
            if ( GsbFlag.SAS_MKT && GsbFlag.AFTER_SAS_CONV )
            {
                if ( ( cStkNo.substr(0,1) === "0" ) && ( cStkNo.trim.length === 6 ) )
                {
                    return cStkNo
                } else {
                    let T_STKNO = cStkNo.padStart(STKNO_LEN)
                    //console.log("STRVAL T_STKNO1: ", T_STKNO)
                    return T_STKNO
                }
            } else {
                //console.log("STRVAL T_STKNO2: ", cStkNo.padStart(STKNO_LEN))
                return cStkNo.padStart(STKNO_LEN)
            }
        } else if ( P_LEN < STKNO_LEN )
        {
            //console.log("STRVAL T_STKNO3: ", cStkNo + " ".repeat(STKNO_LEN - P_LEN))
            return cStkNo + " ".repeat(STKNO_LEN - P_LEN)
        } else if ( P_LEN > STKNO_LEN )
        {
            return cStkNo.substr(0, STKNO_LEN)
        }
    } else {
        if ( lHasNum )
        {
           return cStkNo.padStart(5)
        } else if ( P_LEN < 5 )
        {
            return cStkNo + " ".repeat(5 - P_LEN)
        } else if ( P_LEN > 5 )
        {
            return cStkNo.substr(0,5)
        }
    }
    return cStkNo
}


export function IsHkMarket(sMarket: string): boolean {
    if ( typeof(sMarket) === "undefined") {
        sMarket = ""
    }
    return ( sMarket.trim().length === 0 || sMarket.substr(0,2) === 'HK' || sMarket.substr(0,2) === 'hk' )
}


export function IsHkCurcy(sCurcy: string): boolean {
    if ( typeof(sCurcy) === "undefined") {
        sCurcy = ""
    }
    return ( sCurcy.trim().length === 0 || sCurcy.substr(0,2) === 'HK' || sCurcy.substr(0,2) === 'hk' )
}



export function sortByColumn(a: any , colName: string): any {

    a.sort(sortFunction);

    function sortFunction(a: any, b: any): number {
        a = a[colName]
        b = b[colName]
        return (a === b) ? 0 : (a < b) ? -1 : 1
    }

    return a;
}


export function PerformEnter2Tab(): any {
    //let inputs1 = document.getElementsByTagName("input") ;
    let inputs1 = document.querySelectorAll<any>("input,select,button");
    //20231013 d say disable it
    return inputs1;
    
    for (let i = 0; i < inputs1.length; i++) {
        //console.log("inputs1", inputs1[i].tagName, inputs1[i].name, inputs1[i].id, inputs1[i].type, inputs1[i].disabled ) ;
        inputs1[i].addEventListener("keydown", (e: KeyboardEvent) => {
        if (e.keyCode === 13 && e.shiftKey) {
            e.preventDefault();
            //inputs1[i > 0 ? i - 1 : inputs1.length-1].focus();
            for ( let j = i-1 ; j >= 0; j--) {
                if ( ( inputs1[j].name.length > 0 || inputs1[j].id.length > 0 ) && ! inputs1[j].disabled ) {
                    inputs1[j].focus() ;
                    break ;
                }
            }
        } else if (e.keyCode === 13 && ! e.shiftKey) {
            e.preventDefault();
            //inputs1[i < inputs1.length-1 ? i + 1 : 0].focus();
            for ( let j = i+1 ; j < inputs1.length; j++) {
                //if ( ( inputs1[j].name.length > 0 || inputs1[j].id.length > 0 || inputs1[j].tagName == "BUTTON" ) && ! inputs1[j].disabled ) {
                if ( ( inputs1[j].name.length > 0 || inputs1[j].id.length > 0 ) && ! inputs1[j].disabled ) {
                    inputs1[j].focus() ;
                break ;
                }
            }
        }
      })
    }
    return inputs1;
}


export function openNewWindows (url:string){
    //let features = "resizable,scrollbars=yes,status=1";   //'menubar=yes,location=yes,resizeable=yes,scrollbar=yes,status=yes';
    //let other = window.open(url, "DescriptiveWindowName", features);
    let other = window.open(url, "_blank");
    
}

export function isEmptyDate(dateString: string): boolean {
    return (dateString === "    -  -  ")
}

export function fbsACTypeName(acType: string) {
    switch (acType) {
        case "N":
            return "Normal"
        case "O":
            return "Omnibus"
        case "I":
            return "Instruct"
        case "C":
            return "Cash"
        case "H":
            return "House"
        case "$":
            return "Bank"
        case "A":
            return "A/E"
        case "B":
            return "Broker"
        default:
            return "Unknown"
    }
}

export function fbsComdyTypeName(acType: string) {
    switch (acType) {
        case "O":
            return "Futures & Options"
        case "F":
            return "Futures Only"
        default:
            return "Unknown"
    }
}

export function fbsPositionTypeName(acType: string) {
    switch (acType) {
        case "O":
            return "Open"
        case "G":
            return "Give-Up"
        case "T":
            return "Take-Up"
        default:
            return "Unknown"
    }
}

export function fbsCallPutTypeName(acType: string) {
    switch (acType) {
        case "C":
            return "Call"
        case "P":
            return "Put"
        default:
            return "" // Not option
    }
}

export function fbsBuySellTypeName(acType: string) {
    switch (acType) {
        case "B":
            return "Buy"
        case "S":
            return "Sell"
        default:
            return "Unknown"
    }
}

export function fbsDepositWithdrawTypeName(acType: string) {
    switch (acType) {
        case "D":
            return "Deposit"
        case "W":
            return "Withdraw"
        default:
            return "Unknown"
    }
}




export const buttonStyle = (topValue: number): React.CSSProperties => ({
    position: 'fixed',
    top: topValue,
    right: '50px', // Adjust as needed for horizontal position
    zIndex: 1000, // Ensure it's above other content
    // Add other styling for your button (background, padding, border-radius, etc.)
    //backgroundColor: '#BCD1E9',
    
    padding: '10px 15px',
    borderRadius: '5px',
    cursor: 'pointer',
    border: 'none',
});


export   const toCalendarFormat = (str: string) => {
    if (!str) return "";
    const [d, m, y] = str.split('-');
    return `${y}-${m}-${d}`; //  YYYY-MM-DD
};

export const toStateFormat = (str: string) => {
    if (!str) return "";
    const [y, m, d] = str.split('-');
    return `${d}-${m}-${y}`; //  DD-MM-YYYY
};
// ============================================================================
// 1. CHINA BCAN MAPPINGS (Northbound Stock Connect)
// ============================================================================

/**
 * Maps China BCAN Identity Document Type code to text with a number suffix.
 * Handles padding, spaces, and blank values natively.
 */
export const getChinaBcanDocType = (code: string | null | undefined): string => {
  if (!code) return '';
  
  let cleanCode = code.trim();
  if (cleanCode.length === 2 && cleanCode.startsWith('0')) {
    cleanCode = cleanCode.substring(1);
  }
  
  if (!cleanCode) return '';

  switch (cleanCode) {
    case '1': return '1.Identity Card';
    case '2': return '2.Passport';
    case '3': return '3.Certificate of Incorporation / other official incorporation documents';
    case '4': return '4.LEI';
    case '5': return '5.Other official identity document';
    default: return 'Unknown';
  }
};

/**
 * Maps China BCAN Client Type code to text with a number suffix.
 * Handles padding, spaces, and blank values natively.
 */
export const getChinaBcanClientType = (code: string | null | undefined): string => {
  if (!code) return '';
  
  let cleanCode = code.trim();
  if (cleanCode.length === 2 && cleanCode.startsWith('0')) {
    cleanCode = cleanCode.substring(1);
  }
  
  if (!cleanCode) return '';

  switch (cleanCode) {
    case '1': return '1.Individual';
    case '2': return '2.Joint Account';
    case '3': return '3.Legal Entity - Funds';
    case '4': return '4.Legal Entity - Fund managers and others';
    case '5': return '5.Proprietary or Principal Trading';
    default: return 'Unknown';
  }
};


// ============================================================================
// 2. HKIDR MAPPINGS (Hong Kong Investor Identification Regime)
// ============================================================================

/**
 * Maps HKIDR Identity Document Type code to text with a number suffix.
 * Handles padding, spaces, and blank values natively.
 */
export const getHkidrDocType = (code: string | null | undefined): string => {
  if (!code) return '';
  
  let cleanCode = code.trim();
  if (cleanCode.length === 2 && cleanCode.startsWith('0')) {
    cleanCode = cleanCode.substring(1);
  }
  
  if (!cleanCode) return '';

  switch (cleanCode) {
    case '1': return '1.HKID';
    case '2': return '2.National Identification Document';
    case '3': return '3.Passport';
    case '4': return '4.LEI';
    case '5': return '5.Certificate of Incorporation';
    case '6': return '6.Business Registration Certificate';
    case '7': return '7.Other official incorporation documents';
    default: return 'Unknown';
  }
};

/**
 * Maps HKIDR Client Type code to text with a number suffix.
 * Handles padding, spaces, and blank values natively.
 */
export const getHkidrClientType = (code: string | null | undefined): string => {
  if (!code) return '';
  
  let cleanCode = code.trim();
  if (cleanCode.length === 2 && cleanCode.startsWith('0')) {
    cleanCode = cleanCode.substring(1);
  }
  
  if (!cleanCode) return '';

  switch (cleanCode) {
    case '1': return '1.Individual';
    case '2': return '2.Joint Account';
    case '3': return '3.Funds';
    case '4': return '4.Legal Entity - Fund managers';
    case '5': return '5.Proprietary or Principal Trading';
    case '6': return '6.Legal entity - Others';
    default: return 'Unknown';
  }
};